import React from 'react';

import styles from 'prototypes/securedCard/app.module.scss';
import { CARD_LAST4 } from 'prototypes/securedCard/prototypeAssumptions';

const CardFace = () => (
  <div className={styles.cardFace} aria-hidden="true">
    <div className={styles.cardTop}>
      <span className={styles.cardBrand}>Plannery</span>
      <span className={styles.cardMeta}>Secured</span>
    </div>
    <div className={styles.chipGraphic} />
    <div className={styles.cardBottom}>
      <span>Payroll savings</span>
      <span>•••• {CARD_LAST4}</span>
    </div>
  </div>
);

export default CardFace;
